import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { open: Boolean }

  connect() {
    if (this.openValue && !this.element.open) this.element.showModal()
  }

  close() {
    this.element.close()
  }
}
